import { useQuery } from "@tanstack/react-query";
import { useToast } from "@/hooks/use-toast";
import { useAuthCheck } from "@/hooks/useAuthCheck";
import { useUserProfileData } from "@/hooks/useUserProfileData";
import { UserProfile } from "@/types/database/auth";

export const useProfileQuery = () => {
  const { toast } = useToast();
  const { checkAuth } = useAuthCheck();
  const { fetchUserProfile } = useUserProfileData();

  return useQuery({
    queryKey: ["user-profile"],
    queryFn: async () => {
      try {
        const user = await checkAuth();
        if (!user) return null;
        const profile = await fetchUserProfile(user.id);
        return profile as UserProfile;
      } catch (error) {
        console.error("Error in query function:", error);
        toast({
          variant: "destructive",
          title: "Error",
          description: "Failed to load profile data. Please try again."
        });
        throw error;
      }
    },
    retry: false,
    staleTime: 30000,
  });
};